import { configureStore } from '@reduxjs/toolkit';

import { authSlice } from './slices/authSlices';
import { businessProfileSlice } from './slices/business-profile/businessProfileSlice';
import { serviceSlice } from './slices/service-regist/serviceSlices';
import { orderSlice } from './slices/order/orderSlice';
import { playerSlice } from './slices/player-list/playerSlice';
import { toastSlice } from './slices/notification/toastSlice';
import { fcmSlice } from './slices/notification/fcmSlice';

export const stores = configureStore({
  reducer: {
    auth: authSlice.reducer,
    businessProfile: businessProfileSlice.reducer,
    service: serviceSlice.reducer,
    order: orderSlice.reducer,
    player: playerSlice.reducer,
    toast: toastSlice.reducer,
    fcm: fcmSlice.reducer,
  },
});

export type RootState = ReturnType<typeof stores.getState>;
export type AppDispatch = typeof stores.dispatch;
